/**
 * 書内検索 API の呼び出し（FR-SEARCH-01）。
 *
 * マニフェストの署名 URL（urls.search）へ問い合わせる。署名は期限つきのため
 * signed-fetch が失効時にマニフェストを再取得して 1 度だけやり直す。検索源は
 * サーバ索引（page_text）— クライアント側 pdf.js 抽出は使わない（EP-4）。
 */
import type { SearchHit } from '../core/events';
import type { ManifestSession } from '../core/manifest';
import { signedFetch } from '../source/signed-fetch';

/** サーバ応答（書内検索）。 */
interface SearchResponse {
  query: string;
  hits: SearchHit[];
}

/**
 * 書内検索を実行する。索引の無いブック（urls.search 無し）では空を返す。
 * currentPage を渡すと近傍ヒットが先頭に並ぶ（サーバの並び順ヒント）。
 */
export async function searchInBook(
  session: ManifestSession,
  query: string,
  signal: AbortSignal,
  currentPage?: number,
): Promise<SearchHit[]> {
  if (session.current.urls.search === undefined) {
    return [];
  }
  const suffix =
    '&q=' + encodeURIComponent(query) + (currentPage ? '&page=' + String(currentPage) : '');
  const response = await signedFetch(
    session,
    (manifest) => (manifest.urls.search ?? '') + suffix,
    { signal },
  );
  if (!response.ok) {
    return [];
  }
  const data = (await response.json()) as SearchResponse;
  return Array.isArray(data.hits) ? data.hits : [];
}
